const DG = require('2gis-maps');

export interface HintConfig {
    containers: NodeListOf<HTMLElement>;
}

export class Map {
    protected isLoaded: boolean = false;
    private readonly elements: {
        containers: NodeListOf<HTMLElement>;
    };

    constructor({containers}: HintConfig) {
        this.elements = {
            containers
        };
        this.init();
    }

    public generateMap(container: HTMLElement): void {
        const
            latitude = container.getAttribute(`data-latitude`),
            longitude = container.getAttribute(`data-longitude`),
            marker = container.getAttribute(`data-marker`),
            zoom = container.getAttribute(`data-zoom`);

        const map = DG.map(container, {
            'center': [latitude, longitude],
            'scrollWheelZoom': false,
            'doubleClickZoom': false,
            'fullscreenControl': false,
            'zoomControl': false,
            'zoom': zoom ? zoom : 17
        });
        DG.marker([latitude, longitude]).addTo(map).bindPopup(marker);
    }

    public init() {
        this.elements.containers.forEach(it => {
            this.generateMap(it);
        });
    }
}